import { HomeData } from '../types';

const homeData: HomeData = {
  welcome: "Hi",
  name: "Ich bin Robin",
  skills: [
    "Frontender",
    "Web-Enthusiast",
    "Performance-Optimierer",
    "Barrierefreiheits-Experte",
    "DevOps-Engineer",
    "Nerd",
    "UI Designer",
    "Spielekonsolen-Hacker",
    "Hefe- und Sauerteig Profi",
    "Fullstack-Dev",
    "Prompt-Artist",
  ],
  intro: "Als leidenschaftlicher Frontend-Entwickler mit über {yearsExp} Jahren Erfahrung erschaffe ich elegante, benutzerfreundliche Websites und Anwendungen, die sowohl technisch solide als auch ästhetisch ansprechend sind.",
  buttons: {
    work: "Meine Arbeiten",
    contact: "Kontakt aufnehmen"
  },
  features: [
    {
      title: "Frontend-Expertise",
      desc: "Moderne Frameworks wie React, Next.js und Flutter kombiniert mit starkem Fokus auf Performance, Benutzerfreundlichkeit, Web Vitals und Barrierefreiheit.",
      iconName: "frontend"
    },
    {
      title: "Responsive Design",
      desc: "Makellose Darstellung auf allen Geräten - vom Desktop bis zum Smartphone, mit optimierten Benutzeroberflächen für jede Bildschirmgröße.",
      iconName: "responsive"
    },
    {
      title: "Web-Standards",
      desc: "Sauberer, barrierefreier Code nach aktuellen Standards, der Browserkompatibilität und zukünftige Wartbarkeit gewährleistet.",
      iconName: "standards"
    },
    {
      title: "Docker & Engineering",
      desc: "Erfahrung in der Containerisierung von Anwendungen mit Docker, um eine konsistente Entwicklungs- und Produktionsumgebung zu schaffen.",
      iconName: "docker"
    },
    {
      title: "Cloud-Services",
      desc: "Erfahrung mit Cloudflare, Firebase und Google Cloud, um skalierbare und leistungsstarke Anwendungen zu erstellen.",
      iconName: "cloud"
    },
    {
      title: "Github CI/CD",
      desc: "Automatisierung des gesamten Entwicklungsprozesses mit Github CI/CD, um schnelle und zuverlässige Bereitstellungen zu gewährleisten.",
      iconName: "automation"
    },
    {
      title: "App-Entwicklung",
      desc: "Entwicklung von plattformübergreifenden Anwendungen mit Flutter, die auf iOS / Android und macOS laufen. Deployment auf dem App Store und Google Play.",
      iconName: "app-development"
    },
  ],
  brands: {
    title: "Unternehmen und Marken, mit denen ich zusammengearbeitet habe",
    groups: [
      ["Allianz", "Daimler AG", "Deutsche Post", "Deutsche Telekom", "Lufthansa", "Volkswagen", "Montblanc", "Mercedes", "Netflix"],
      ["Dr. Oetker", "SEAT", "Storck", "Gerolsteiner", "Migros", "Swatch", "Unilever", "Red Bull", "IKEA", "DPD"],
      ["Hubert Burda", "Osram", "Peta", "Imperial Tobacco", "Dräger", "Palmers", "Tesa", "Deutscher Ring", "Gruner + Jahr", "Tchibo"],
      ["Coca-Cola", "TV-Today", "Otto", "Swarovski", "Yogi Tea", "EnBW", "apo.com Group", "Burger King", "TV-Spielfilm", "Fit for Fun", "FRoSTA", "Hapag Lloyd", "Studioline"]
    ]
  },
  stats: [
    {
      number: "{formattedYears}",
      label: "Jahre Erfahrung"
    },
    {
      number: "100+",
      label: "abgeschlossene Projekte"
    },
    {
      number: "50+",
      label: "zufriedene Kunden"
    },
    {
      number: "24/7",
      label: "Support-Bereitschaft"
    }
  ],
  cta: {
    title: "Interessiert an einer Zusammenarbeit?",
    desc: "Lass uns über Dein nächstes Projekt sprechen und wie ich Dir helfen kann, Deine digitale Präsenz auf die nächste Stufe zu heben.",
    button: "Kontakt aufnehmen"
  }
};

export default homeData;